import React, { useState, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Modal,
  Paper
} from '@material-ui/core';

import ReturnOrderDetails from 'components/ReturnOrders/ReturnOrderDetails';
import ReturnOrdersTable from 'components/ReturnOrders/ReturnOrdersTable';
import ReturnOrderInvoice from 'components/Invoices/ReturnOrderInvoice';

const ReturnOrderListResults = (props) => {

  const printRef = useRef();
  
  const [open, setOpen] = useState(false);
  const [openInvoiceModal, setOpenInvoiceModal] = useState(false);
  const [invoiceBuffer, setInvoiceBuffer] = useState({});

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: "Return Order Invoice"
  });

  const addReturnOrder = () => {
    setOpen(true);
  };

  const handleInvoiceModalOpen = (invoiceInfo) => {
    setOpenInvoiceModal(true);
    setInvoiceBuffer(invoiceInfo);
  };

  const handleInvoiceModalClose = () => {
    setOpenInvoiceModal(false);
    setInvoiceBuffer({});
  };
  
  const createRODisplayId = () => {
    const length = props.idGen.find(idGen => idGen.info.user === props.activeUserId).body.returnOrder;
    let RONum;
    length < 100 ? 
      RONum = new Array(3 + 1 - (length + '').length).join('0') + length
    : RONum = length
    return ("RO-" + RONum);
  };

  return (
    <Box>
      { !open ?
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end'
        }}
      > 
        <Button
          color="primary"
          variant="contained"
          onClick={addReturnOrder}
        >
          New R.O.
        </Button>
      </Box> : null }
      <Box sx={{ mt: 3 }}>
      { open ?
        <ReturnOrderDetails
          activeUserId={props.activeUserId}
          products={props.products}
          vendors={props.vendors}
          createRODisplayId={createRODisplayId}
          setOpen={setOpen}
          openModal={handleInvoiceModalOpen}
        /> :
        <ReturnOrdersTable
          returnOrders={props.returnOrders}
          products={props.products}
          vendors={props.vendors}
        />
      }
      </Box>
      { openInvoiceModal ?
      <Modal open={openInvoiceModal}>
        <Card>
          <CardHeader
            subheader="Please Review The Invoice"
            title="Print Invoice"
          />
          <Divider />
          <CardContent>
            <Box>
              <Paper
                style={{
                  overflow: 'auto',
                  maxHeight: 469
                }}
              >
                <ReturnOrderInvoice
                  ref={printRef}
                  info={invoiceBuffer}
                  user={props.user}
                />
              </Paper>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  paddingTop: '1%'
                }}
              >
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => {
                    handlePrint();
                    handleInvoiceModalClose();
                  }}
                >
                  Print Invoice
                </Button>
              </Box>
            </Box>
          </CardContent>
          <Divider />
        </Card>
      </Modal> : null }
    </Box>
  )
};

export default ReturnOrderListResults;